import React from "react";

const BloodTestIcon = () => {
  return (
    <svg
      width="21"
      height="30"
      viewBox="0 0 21 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3778_18"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="30"
      >
        <path
          d="M10.4838 0.425781C10.5835 0.571168 10.6598 0.678072 10.7304 0.788537C13.1499 4.58856 15.5666 8.39072 17.9883 12.1893C19.5291 14.6067 20.2917 17.2365 20.2226 20.1093C20.1157 24.4852 16.8231 28.447 12.5327 29.3015C7.30591 30.3435 2.32569 27.2105 1.04286 22.1783C0.355125 19.4829 0.772756 16.8609 1.84891 14.3402C2.22449 13.4615 2.71838 12.629 3.23008 11.8173C5.53134 8.16551 7.8561 4.53083 10.1737 0.888312C10.2664 0.742925 10.3662 0.601814 10.4823 0.425781H10.4845H10.4838Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3778_18)">
        <path
          d="M10.5472 0.316895C10.647 0.462282 10.7233 0.569184 10.7938 0.679649C13.2134 4.47967 15.6301 8.28183 18.0518 12.0804C19.5926 14.4978 20.3552 17.1276 20.286 20.0005C20.1791 24.3763 16.8865 28.3381 12.5962 29.1926C7.36939 30.2346 2.38917 27.1016 1.10634 22.0694C0.418601 19.374 0.836233 16.7521 1.91238 14.2313C2.28797 13.3526 2.78186 12.5202 3.29356 11.7084C5.59481 8.05662 7.91958 4.42194 10.2372 0.779426C10.3299 0.634038 10.4296 0.492927 10.5458 0.316895H10.548H10.5472Z"
          fill="#F04E4E"
        />
        <path
          d="M21.9787 -3.31152H10.4418V30.0798H21.9787V-3.31152Z"
          fill="#C51F4B"
        />
      </g>
      <path
        d="M11.7502 14.948H9.31995C9.29643 14.9936 9.27434 15.015 9.27292 15.0385C9.26579 15.6885 9.25082 16.3377 9.26009 16.9855C9.26365 17.2599 9.18383 17.3739 8.89163 17.3647C8.3108 17.3469 7.72853 17.3704 7.14556 17.354C6.88614 17.3469 6.77568 17.436 6.77924 17.6989C6.78637 18.309 6.78851 18.9169 6.77924 19.5262C6.77354 19.8092 6.89755 19.909 7.16979 19.9054C7.68363 19.8961 8.1989 19.9033 8.71275 19.9054C9.0755 19.9054 9.25795 20.0814 9.25938 20.4335C9.25938 20.9616 9.24512 21.4897 9.2722 22.0164C9.27791 22.1304 9.42258 22.3321 9.5081 22.3342C10.2429 22.3599 10.9798 22.3485 11.753 22.3485V19.8405H14.1576V17.3797H11.753V14.9494L11.7509 14.9473L11.7502 14.948Z"
        fill="white"
      />
    </svg>
  );
};

export default BloodTestIcon;
